import { useIntl } from 'react-intl'
import { makePublicUrl } from 'app/utils/publicUrl'
import Counter from 'components/Counter'
import { Dispatch, SetStateAction } from 'react'
import { purchaseSubscriptionMessages } from '../../messages'
import {
  PurchaseSubscriptionBlock,
  PurchaseSubscriptionBlockWrapper,
  PurchaseSubscriptionContentBlock,
  PurchaseSubscriptionHeader,
  PurchaseSubscriptionHeaderLinkButton,
  PurchaseSubscriptionHeaderTitle,
  PurchaseSubscritpionBlockItem,
  PurchaseSubscritpionItemSubtitle,
  PurchaseSubscritpionItemTitle,
  StyledPurchaseItemImg,
} from '../../styles'
import { formatPrice } from 'features/home/components/HomeSubscription/utils'
import Checkbox from 'components/Input/Checkbox'

export interface AddDeviceStepProps {
  setApQuantity: Dispatch<SetStateAction<number>>
  setApEnabled: Dispatch<SetStateAction<boolean>>
  apEnabled: boolean
  apQuantity: number
  amount: number
  networkAiEnabled: boolean
  setNetworkAiEnabled: Dispatch<SetStateAction<boolean>>
}

const AddDeviceStep = (props: AddDeviceStepProps) => {
  const {
    apEnabled,
    apQuantity,
    amount,
    setApEnabled,
    setApQuantity,
    networkAiEnabled,
    setNetworkAiEnabled,
  } = props
  const { formatMessage } = useIntl()

  return (
    <PurchaseSubscriptionBlock>
      <PurchaseSubscriptionHeader>
        {false && (
          <Checkbox
            checked={networkAiEnabled}
            onChange={() => {
              setNetworkAiEnabled(!networkAiEnabled)
            }}
          />
        )}

        <PurchaseSubscriptionHeaderTitle>
          {formatMessage(
            purchaseSubscriptionMessages.networkAISubscriptionLabel
          )}
        </PurchaseSubscriptionHeaderTitle>
        <PurchaseSubscriptionHeaderLinkButton></PurchaseSubscriptionHeaderLinkButton>
      </PurchaseSubscriptionHeader>
      <PurchaseSubscriptionContentBlock>
        <PurchaseSubscriptionBlockWrapper
          disabled={!apEnabled || !networkAiEnabled}
        >
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.accessPointsLabel)}
            </PurchaseSubscritpionItemTitle>
            {false && (
              <Checkbox
                checked={apEnabled}
                disabled={!networkAiEnabled}
                onChange={() => {
                  setApEnabled(!apEnabled)
                }}
              />
            )}
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/access-points.svg`)}
            />
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatPrice(amount)}/y
            </PurchaseSubscritpionItemTitle>
            <Counter
              disabled={!apEnabled || !networkAiEnabled}
              increment={() => setApQuantity((prev) => ++prev)}
              decrement={() =>
                setApQuantity((prev) => {
                  const newValue = --prev
                  return newValue > 0 ? newValue : 0
                })
              }
              value={apQuantity}
            />
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionBlockWrapper>
        <PurchaseSubscriptionBlockWrapper disabled>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.switchesLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/switches.svg`)}
            />
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemSubtitle>
              {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
            </PurchaseSubscritpionItemSubtitle>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionBlockWrapper>
        <PurchaseSubscriptionBlockWrapper disabled>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemTitle>
              {formatMessage(purchaseSubscriptionMessages.wanEdgesLabel)}
            </PurchaseSubscritpionItemTitle>
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <StyledPurchaseItemImg
              src={makePublicUrl(`images/networkIcons/wan-edges.svg`)}
            />
          </PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemSubtitle>
              {formatMessage(purchaseSubscriptionMessages.comingSoonLabel)}
            </PurchaseSubscritpionItemSubtitle>
          </PurchaseSubscritpionBlockItem>
        </PurchaseSubscriptionBlockWrapper>
      </PurchaseSubscriptionContentBlock>
    </PurchaseSubscriptionBlock>
  )
}

export default AddDeviceStep
